'use client'

import { useTranslations } from '@/lib/next-shim'

type SaveAddressCheckboxProps = {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  label: string
  onLabelChange: (label: string) => void
}

export function SaveAddressCheckbox({ checked, onCheckedChange, label, onLabelChange }: SaveAddressCheckboxProps) {
  const t = useTranslations('address')

  return (
    <div className="space-y-2">
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onCheckedChange(e.target.checked)}
          className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
        />
        <span className="text-sm text-gray-700">{t('saveThisAddress')}</span>
      </label>
      {checked && (
        <input
          type="text"
          value={label}
          onChange={(e) => onLabelChange(e.target.value)}
          placeholder={t('addressLabelPlaceholder')}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        />
      )}
    </div>
  )
}
